import { render } from "./ShortPreview.vue?vue&type=template&id=923eb82a"
import script from "./ShortPreview.vue?vue&type=script&lang=js"
export * from "./ShortPreview.vue?vue&type=script&lang=js"

import "./ShortPreview.vue?vue&type=style&index=0&id=923eb82a&lang=stylus"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__